import { useBoardStore } from '../store/useBoardStore';
import { foldBoardIntentSummary, pushBoardIntentEvent } from './boardRecentIntent';

/**
 * Push an intent event, fold it into board.recentIntent, and keep the local
 * board field in sync so the next Ask / Do-next / chat turn sees it.
 */
export function recordBoardIntent(hashtag, event) {
  const tag = String(hashtag || '').trim();
  if (!tag || !event?.type) return '';
  pushBoardIntentEvent(tag, event);
  const store = useBoardStore.getState();
  const nextIntent = foldBoardIntentSummary(tag, {
    priorSummary: store.board?.recentIntent || '',
  });
  store.updateRecentIntentLocal(nextIntent);
  return nextIntent;
}
